import { lazy, ReactElement } from 'react'

import { useSearchParams } from 'react-router-dom'

import { signInAuthorizationCode } from '../services/api/auth'
import { getRecaptchaToken } from '../services/recaptcha'
import { SignInOptions } from '../types/SignInOptions'
import { redirectToUrl } from '../utils/location'
import { QueryParameters } from '../utils/queryParameters'

const LazySignInPage = lazy(() =>
  import('../pages/signin/SignInPage').then((module) => ({
    default: module.SignInPage,
  })),
)

export const SignInPartnerRoute = (): ReactElement => {
  const [searchParams] = useSearchParams()

  const signInAuthorizationCodeSubmit = async ({
    username,
    password,
    authenticationCode,
    secondaryFactor,
  }: SignInOptions): Promise<void> => {
    const recaptchaToken = await getRecaptchaToken('login')
    const redirectTo = searchParams.get(QueryParameters.REDIRECT_TO) || ''
    const url = await signInAuthorizationCode(
      username,
      password,
      recaptchaToken,
      redirectTo,
      authenticationCode,
      secondaryFactor,
    )
    redirectToUrl(url.redirect_to)
  }

  return <LazySignInPage onSubmit={signInAuthorizationCodeSubmit} enableSso={false} />
}
